const optionsPrice = {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2,
  maximumFractionDigits: 3,
}
export const formatPrice = new Intl.NumberFormat('pt-BR', optionsPrice)
